import { render } from "./portskills.vue?vue&type=template&id=364cb3f6"
import script from "./portskills.vue?vue&type=script&lang=js"
export * from "./portskills.vue?vue&type=script&lang=js"

import "./portskills.vue?vue&type=style&index=0&id=364cb3f6&lang=scss"

import exportComponent from "C:\\laragon\\www\\juani\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__